import { memberPicksLine } from '@splitfiesta/core';
import { useTranslation } from '@splitfiesta/i18n';
import type { ExpenseLineItem } from '@splitfiesta/shared';

interface MemberPicksLineProps {
  items: readonly ExpenseLineItem[];
  userId: string;
}

/** The second line of a split-card row on an itemised expense: one pill per item the member holds. */
export function MemberPicksLine({ items, userId }: MemberPicksLineProps) {
  const { t } = useTranslation('expenses');
  const labels = memberPicksLine(items, userId).map(pick =>
    pick.units > 1
      ? t('lineItems.pickedUnits', { name: pick.name, units: pick.units })
      : pick.name
  );

  if (labels.length === 0) {
    return (
      <p
        data-testid={`member-picks-${userId}`}
        className="text-xs text-gray-500 dark:text-gray-400"
      >
        {t('lineItems.memberNothingPicked')}
      </p>
    );
  }

  return (
    <ul
      data-testid={`member-picks-${userId}`}
      aria-label={labels.join(', ')}
      className="flex flex-row flex-wrap gap-1"
    >
      {labels.map((label, idx) => (
        <li
          key={`${label}-${idx}`}
          className="rounded-full bg-gray-100 dark:bg-gray-800 px-2 py-0.5 text-xs text-gray-700 dark:text-gray-300 break-words"
        >
          {label}
        </li>
      ))}
    </ul>
  );
}
